<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div>
          <template>
            <v-card>
              <v-dialog persistent v-model="dialog" max-width="900px">
                <template v-slot:activator="{ on }">
                  <div class="d-flex">
                    <v-btn color="#00004d" dark class="ml-auto ma-3" @click="refreshData">
                      <i style="color: #fff" class="flaticon2-refresh-1"></i>
                    </v-btn>
                    <v-btn color="#00004d" dark class="ma-3 ml-0" v-on="on">
                      Add
                      <v-icon class="ml-2" small>fas fa-plus-circle</v-icon>
                    </v-btn>
                  </div>
                </template>
                <v-card>
                  <i class="fas fa-times custom-times" @click="closeDialog"></i>
                  <v-card-title>
                    <span v-if="editedItem.id">Edit Notification</span>
                    <span v-else>Add Notification</span>
                  </v-card-title>
                  <v-card-text>
                    <v-form
                        ref="form"
                        v-model="validationRules.valid"
                        lazy-validation
                    >
                      <v-row>
                        <v-col cols="12">
                          <div class="mb-1 font-weight-bold">Send to</div>
                          <v-radio-group
                              v-model="editedItem.send_to"
                              row
                              :rules="validationRules.selectRules"
                              hide-details="auto"
                          >
                            <v-radio label="All Brokers" value="all"></v-radio>
                            <v-radio label="Selected Brokers" value="selected"></v-radio>
                          </v-radio-group>
                        </v-col>
                        <v-col cols="12" v-if="editedItem.send_to === 'selected'">
                          <v-autocomplete
                              v-model="editedItem.user_ids"
                              :items="brokerFilter"
                              item-text="label"
                              item-value="id"
                              label="Select Brokers*"
                              multiple
                              chips
                              small-chips
                              deletable-chips
                              outlined
                              dense
                              clearable
                              :rules="validationRules.multipleRules"
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12">
                          <div class="mb-1 font-weight-bold">Priority</div>
                          <v-radio-group
                              v-model="editedItem.priority"
                              row
                              :rules="validationRules.selectRules"
                              hide-details="auto"
                          >
                            <v-radio label="High" value="high"></v-radio>
                            <v-radio label="Medium" value="medium"></v-radio>
                            <v-radio label="Low" value="low"></v-radio>
                          </v-radio-group>
                        </v-col>
                        <v-col cols="12">
                          <div class="mb-2 font-weight-bold">Message</div>
                          <editor
                              :api-key="tinyKey"
                              ref="rc_editor"
                              v-model="editedItem.description"
                              :init="notificationEditorInit"
                          />
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closeDialog">Cancel</v-btn>
                    <v-btn :disabled="!validationRules.valid" color="blue darken-1" text @click="saveItem(editedItem)">
                      Save
                    </v-btn>
                  </v-card-actions>
                  <v-col cols="12">
                    <div v-if="errors!=undefined && errors.length >= 0"
                         role="alert"
                         v-bind:class="{ show: errors.length }"
                         class="alert fade alert-danger"
                    >
                      <div class="alert-text" v-for="(error, i) in errors" :key="i">
                        {{ error }}
                      </div>
                    </div>
                  </v-col>
                </v-card>
              </v-dialog>
              <hr style="margin:0"/>
              <v-card-title>
                Notifications ({{ addTSBVZ(totalRecords) }})
                <v-spacer></v-spacer>
                <v-text-field
                    @keydown.enter="searchQueryData"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
                ></v-text-field>
              </v-card-title>
              <v-skeleton-loader :loading="loading" v-if="isLoaded" type="table"></v-skeleton-loader>
              <v-data-table
                  :headers="headers"
                  :items="items"
                  :options.sync="pagination"
                  :server-items-length="totalRecords"
                  :footer-props="{
                    itemsPerPageOptions: rowsPerPageItems,
                    showFirstLastPage: true,
                  }"
                  :loading="loading"
                  v-show="!isLoaded"
                  mobile-breakpoint="100"
                  class="elevation-0">
                <template v-slot:item.audience_label="{ item }">
                  <div class="text-truncate">
                    <p>{{ item.audience_label }}</p>
                  </div>
                </template>
                <template v-slot:item.priority="{ item }">
                  <v-chip small :color="priorityColor(item.priority)" text-color="white">
                    {{ item.priority_label || (item.priority ? item.priority : '—') }}
                  </v-chip>
                </template>
                <template v-slot:item.message_preview="{ item }">
                  <div class="text-truncate" style="max-width: 360px;">
                    <p>{{ item.message_preview }}</p>
                  </div>
                </template>
                <template v-slot:item.assigned_by_name="{ item }">
                  <div class="text-truncate">
                    <p>{{ item.assigned_by_name || (item.assigned_by_user ? item.assigned_by_user.name : '') }}</p>
                  </div>
                </template>
                <template v-slot:item.created_at="{ item }">
                  <div class="text-truncate">
                    {{ formatDateAndTime(item.created_at) }}
                  </div>
                </template>
                <template v-slot:item.actions="{ item }">
                  <div class="text-truncate">
                    <v-btn color="#00004d" @click="showViewDialog(item)" dark class="mr-2">
                      View
                      <v-icon dark right small>fas fa-eye</v-icon>
                    </v-btn>
                    <v-btn color="#00004d" @click="showEditDialog(item)" dark class="mr-2">
                      Edit
                      <v-icon dark right small>fas fa-edit</v-icon>
                    </v-btn>
                    <v-btn @click="deleteItem(item)" color="warning" dark class="mr-2">
                      Delete
                      <v-icon dark right small>fas fa-trash</v-icon>
                    </v-btn>
                  </div>
                </template>
              </v-data-table>
            </v-card>
          </template>
        </div>
      </div>
    </div>

    <v-dialog persistent v-model="viewDialog" max-width="800px" scrollable>
      <v-card>
        <i class="fas fa-times custom-times" @click="closeViewDialog"></i>
        <v-card-title>View Notification</v-card-title>
        <v-card-text>
          <div v-if="!viewItem.id" class="py-6 text-center grey--text">Loading…</div>
          <div v-else>
            <v-row>
              <v-col cols="12" md="6">
                <div class="mb-1 font-weight-bold">Send to</div>
                <p class="mb-3">{{ viewItem.audience_label || (viewItem.send_to === 'selected' ? 'Selected Brokers' : 'All Brokers') }}</p>
              </v-col>
              <v-col cols="12" md="6">
                <div class="mb-1 font-weight-bold">Priority</div>
                <v-chip small :color="priorityColor(viewItem.priority)" text-color="white">
                  {{ viewItem.priority_label || (viewItem.priority ? viewItem.priority : '—') }}
                </v-chip>
              </v-col>
              <v-col cols="12" md="6">
                <div class="mb-1 font-weight-bold">Created by</div>
                <p class="mb-3">{{ viewCreatedBy }}</p>
              </v-col>
              <v-col cols="12" md="6">
                <div class="mb-1 font-weight-bold">Created</div>
                <p class="mb-3">{{ viewItem.created_at ? formatDateAndTime(viewItem.created_at) : '—' }}</p>
              </v-col>
              <v-col cols="12" v-if="viewRecipientLabels.length">
                <div class="mb-2 font-weight-bold">Brokers</div>
                <v-chip
                    v-for="label in viewRecipientLabels"
                    :key="label"
                    small
                    class="mr-2 mb-2"
                    outlined
                >
                  {{ label }}
                </v-chip>
              </v-col>
              <v-col cols="12">
                <div class="mb-2 font-weight-bold">Message</div>
                <div
                    class="notification-view-body pa-3"
                    v-html="viewItem.description ? sanitizeRichHtml(viewItem.description) : '—'"
                ></div>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeViewDialog">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {mapState} from "vuex";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import {
  ADMIN_NOTIFICATIONS_LIST,
  BROKERS_SIMPLE_LIST,
  CREATE_NOTIFICATION,
  UPDATE_NOTIFICATION,
  DELETE_NOTIFICATION,
  GET_NOTIFICATION_DETAILS,
  CLEAR_NOTIFICATION_ERRORS,
} from "@/core/services/store/notifications.module";
import {SET_CONFIRMATION} from "@/core/services/store/confirmation.module";

export default {
  name: 'notifications',
  data() {
    return {
      headers: [
        {text: 'Send To', value: 'audience_label', name: 'user_ids', filterable: false, sortable: false},
        {text: 'Priority', value: 'priority', name: 'priority', filterable: true, sortable: true},
        {text: 'Message', value: 'message_preview', name: 'description', filterable: true, sortable: false},
        {text: 'Created By', value: 'assigned_by_name', name: 'assigned_by', filterable: false, sortable: false},
        {text: 'Created', value: 'created_at', name: 'created_at', filterable: false, sortable: true},
        {text: 'Actions', value: 'actions', name: 'actions', filterable: false, sortable: false},
      ],
      isLoaded: true,
      draw: 1,
      searchQuery: "",
      loading: true,
      pagination: {
        page: 1,
        rowsPerPage: 25,
        totalItems: 0,
        sortDesc: "desc"
      },
      totalRecords: 0,
      rowsPerPageItems: [25, 50, 100, 150, 200],
      headerindex: "",
      columns: [],
      validationRules: {
        valid: true,
        selectRules: [
          v => !!v || "This field is required"
        ],
        multipleRules: [
          v => {
            if (!v || v.length < 1) return "Select at least one broker";
            return true;
          }
        ]
      },
      items: [],
      dialog: false,
      viewDialog: false,
      viewItem: {},
      brokerFilter: [],
      editedItem: {
        send_to: 'all',
        user_ids: [],
        priority: 'medium',
        description: ''
      },
    }
  },
  computed: {
    notificationEditorInit() {
      return Object.assign({}, this.tinyEditorInit, {height: 280});
    },
    params() {
      return {
        ...this.pagination,
        query: this.searchQuery
      };
    },
    ...mapState({
      errors: state => state.notifications.errors
    }),
    viewCreatedBy() {
      if (this.viewItem.assigned_by_name) return this.viewItem.assigned_by_name;
      if (this.viewItem.assigned_by_user && this.viewItem.assigned_by_user.name) {
        return this.viewItem.assigned_by_user.name;
      }
      return '—';
    },
    viewRecipientLabels() {
      const ids = Array.isArray(this.viewItem.user_ids) ? this.viewItem.user_ids : [];
      if (!ids.length) return [];
      return ids.map((id) => {
        const broker = this.brokerFilter.find((item) => Number(item.id) === Number(id));
        return broker ? (broker.label || broker.name) : ('Broker #' + id);
      });
    }
  },
  watch: {
    params: {
      handler() {
        this.loadData().then(response => {
          this.items = response.items;
          this.totalRecords = response.total;
        });
      },
      deep: true
    },
    dialog(val) {
      !val && this.$store.dispatch(CLEAR_NOTIFICATION_ERRORS);
      if (!val) this.editedItem = this.emptyItem();
    }
  },
  mounted() {
    for (let i = 0; i < this.headers.length; i++) {
      this.columns.push(
          '&columns[' + i + '][data]=' + this.headers[i].value +
          '&columns[' + i + '][name]=' + this.headers[i].name +
          '&columns[' + i + '][searchable]=' + this.headers[i].filterable +
          '&columns[' + i + '][orderable]=' + this.headers[i].sortable +
          '&columns[' + i + '][search][value]=' +
          '&columns[' + i + '][search][regex]=' + false
      );
    }
    this.$store.dispatch(SET_BREADCRUMB, [
      {title: "More"},
      {title: "Notifications"}
    ]);
    this.getBrokers();
  },
  methods: {
    emptyItem() {
      return {
        send_to: 'all',
        user_ids: [],
        priority: 'medium',
        description: ''
      };
    },
    priorityColor(priority) {
      if (priority === 'high') return 'error';
      if (priority === 'medium') return 'orange';
      if (priority === 'low') return 'success';
      return 'grey';
    },
    refreshData() {
      this.loadData().then(response => {
        this.items = response.items;
        this.totalRecords = response.total;
      });
    },
    searchQueryData: function (e) {
      if (e.keyCode === 13) {
        this.searchQuery = e.target.value;
      }
    },
    getHeaderIndex(name) {
      let that = this;
      this.headers.filter(function (ele, i) {
        if (name == ele.name) {
          that.headerindex = i;
        }
      });
    },
    loadData() {
      this.loading = true;
      this.isLoaded = true;
      return new Promise((resolve) => {
        let params = this.params;
        params.length = params.itemsPerPage;
        params.start =
            params.page == 1 ? 0 : params.itemsPerPage * (params.page - 1);
        params.draw = this.draw;
        let query = Object.keys(params).map((key) => {
          return encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
        }).join('&');
        this.getHeaderIndex(params.sortBy[0]);
        query +=
            "&search[value]=" +
            params.query +
            "&search[regex]=" +
            false +
            "&order[0][column]=" +
            (params.sortBy.length === 0 ? 4 : this.headerindex) +
            "&order[0][dir]=" +
            (params.sortDesc[0] ? "desc" : "asc");
        this.$store.dispatch(ADMIN_NOTIFICATIONS_LIST, {q: query, columns: this.columns}).then((res) => {
          this.draw++;
          let items = res.records.data;
          let total = res.records.recordsFiltered;
          this.loading = !this.loading;
          this.isLoaded = !this.isLoaded;
          resolve({
            items,
            total
          });
        });
      });
    },
    getBrokers() {
      this.$store.dispatch(BROKERS_SIMPLE_LIST).then(data => {
        this.brokerFilter = data.records || [];
      });
    },
    showViewDialog(item) {
      this.viewItem = {};
      this.viewDialog = true;
      this.$store.dispatch(GET_NOTIFICATION_DETAILS, item.id).then((data) => {
        this.viewItem = data.records || {};
      });
    },
    closeViewDialog() {
      this.viewDialog = false;
      this.viewItem = {};
    },
    showEditDialog(item) {
      this.$store.dispatch(GET_NOTIFICATION_DETAILS, item.id).then((data) => {
        const record = data.records || {};
        this.editedItem = {
          id: record.id,
          send_to: record.send_to || (record.user_ids && record.user_ids.length ? 'selected' : 'all'),
          user_ids: Array.isArray(record.user_ids) ? record.user_ids : [],
          priority: record.priority || 'medium',
          description: record.description || ''
        };
        this.dialog = true;
      });
    },
    closeDialog() {
      this.dialog = false;
    },
    saveItem(item) {
      if (this.$refs.form.validate()) {
        const payload = {
          send_to: item.send_to,
          user_ids: item.send_to === 'selected' ? (item.user_ids || []) : [],
          priority: item.priority,
          description: item.description || ''
        };
        let method = CREATE_NOTIFICATION;
        let id = item.id;
        if (id) {
          method = UPDATE_NOTIFICATION;
        }
        this.$store.dispatch(CLEAR_NOTIFICATION_ERRORS);
        this.$store.dispatch(method, {'slug': id, data: payload}).then(() => {
          this.loadData().then(response => {
            this.items = response.items;
            this.totalRecords = response.total;
          });
          this.editedItem = this.emptyItem();
          this.dialog = false;
        })
      }
    },
    deleteItem(item) {
      let that = this;
      this.$store.dispatch(SET_CONFIRMATION, {
        title: "Are you sure?",
        msg: "You want to delete this notification?",
        clr: 'red',
        callback: function () {
          this.$store.dispatch(DELETE_NOTIFICATION, {
            'id': item.id
          }).then(() => {
            that.loadData().then(response => {
              that.items = response.items;
              that.totalRecords = response.total;
            });
          });
        }
      });
    },
  }
};
</script>

<style scoped>
.notification-view-body {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background: #fafafa;
  line-height: 1.55;
}
.notification-view-body >>> img {
  max-width: 100%;
  height: auto;
}
</style>
